import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { LanguageOption, Question } from "types/external/swayam/assignment"
import { LANGUAGE_OPTIONS } from "utils/external/swayam/assignment"

interface ProblemState {
  currentQuestionIndex: number
  questions: Question[]
  codeEditorValue: string
  codeProgLanguage: LanguageOption
}

const initialState: ProblemState = {
  currentQuestionIndex: 0,
  questions: [],
  codeEditorValue: "",
  codeProgLanguage: LANGUAGE_OPTIONS[0]!,
}

const ProblemSlice = createSlice({
  name: "swayamProblem",
  initialState,
  reducers: {
    setCurrentQuestionIndex: (state, action: PayloadAction<number>) => {
      state.currentQuestionIndex = action.payload
    },
    setQuestions: (state, action: PayloadAction<Question[]>) => {
      state.questions = action.payload
    },
    setCodeProgLanguage: (state, action: PayloadAction<LanguageOption>) => {
      state.codeProgLanguage = action.payload
    },
    setCodeEditorValue: (state, action: PayloadAction<string>) => {
      state.codeEditorValue = action.payload
    },
    reset: () => initialState,
  },
})

export const { setCurrentQuestionIndex, setQuestions, setCodeProgLanguage, setCodeEditorValue, reset } =
  ProblemSlice.actions
export default ProblemSlice.reducer
